import React, { memo } from "react";
import { Question } from "./types";

type QuestionItemProps = {
  question: Question;
  onSelect: (question: string) => void;
  className?: string;
};

function QuestionItemComponent({
  question,
  onSelect,
  className,
}: QuestionItemProps) {
  return (
    <button className={className} onClick={() => onSelect(question.question)}>
      <p className="text-sm text-[#000000d9]">{question.question}</p>
    </button>
  );
}

export const QuestionItem = memo<QuestionItemProps>(QuestionItemComponent);
